/* eslint-disable comma-dangle */
/* eslint-disable no-lonely-if */
/* eslint-disable radix */
import { useApolloClient } from '@apollo/client';
import {
    involveAsiaClickIdCookie, involveAsiaMediumCookie, involveAsiaSourceCookie, modules,
} from '@config';
import { removeCartId, setCartId } from '@helper_cartid';
import { getHost, getStoreHost } from '@helper_config';
import { setCheckoutData, removeInvolveAsiaCookie } from '@helper_cookies';
import { storeConfigVar } from '@core/services/graphql/cache';
import { localTotalCart } from '@services/graphql/schema/local';
import React, { useEffect, useState, useRef } from 'react';
import Router from 'next/router';
import Cookies from 'js-cookie';
import { getIpayUrl } from '@core_modules/checkout/helpers/config';
import gqlService from '@core_modules/checkout/services/graphql';
import Skeleton from '@common_skeleton';
import SummaryPlugin from '@plugin_summary';

import ModalXendit from '@core_modules/checkout/pages/default/components/ModalXendit/index';
import { getAppEnv } from '@core/helpers/env';

import { useDispatch, useSelector } from 'react-redux';
import { selectCheckoutState, setLoading, setCheckoutData as setCheckoutDataState } from '@core_modules/checkout/redux/checkoutSlice';
import Button from '@common/Button';
import _ from 'lodash';
import { filterSpecialChars, formatPhoneNumber } from '@helpers/formInput';
import { getCardToken } from '@core_modules/checkout/components/midtransCoreAPI/helpers';

import { createToken } from '@core_modules/checkout/components/xenditCoreAPI/helpers/createToken';
import { getXenditKeyDev, getXenditKey } from '@helpers/env';
import useMediaQuery from '@hook/useMediaQuery';

const getGaCookieSegments = () => {
    if (typeof window === 'undefined') return { third: '', fourth: '' };
    const gaCookieValue = Cookies.get('_ga');
    if (!gaCookieValue) return { third: '', fourth: '' };
    const parts = gaCookieValue.split('.');
    return {
        third: parts[2] || '',
        fourth: parts[3] || '',
    };
};

const Summary = ({
    t,
    handleOpenMessage,
    formik,
    updateFormik,
    config,
    refSummary,
    storeConfig,
    checkoutTokenState,
    setCheckoutTokenState,
    buttonOnly = false,
    isPersonalDataConsentCustomer = false,
    // handleSendPostback = () => {},
}) => {
    const dispatch = useDispatch();
    const checkout = useSelector(selectCheckoutState);

    const { order: loading, all: disabled, totalPrice } = checkout.loading;
    const errorItems = checkout?.data?.errorItems;
    const isSelectedPurchaseOrder = checkout.selected.payment === 'purchaseorder';

    // origin name config
    const originName = modules.checkout.checkoutOnly ? 'pwa-checkout' : 'pwa';

    const globalCurrency = storeConfig.default_display_currency_code;
    // prettier-ignore
    const isPurchaseOrderApply = isSelectedPurchaseOrder && checkout.status.purchaseOrderApply;

    const client = useApolloClient();
    const tempMidtransOrderId = [];
    const [orderId, setOrderId] = useState(null);
    const [snapOrderId, setSnapOrderId] = useState([]);
    const [snapOpened, setSnapOpened] = useState(false);
    const [snapClosed, setSnapClosed] = useState(false);
    const [getSnapToken, manageSnapToken] = gqlService.getSnapToken({ onError: () => {} });
    const [setPaymentMethod] = gqlService.setPaymentMethod();
    const [placeOrder] = gqlService.placeOrder();
    const [placeOrderWithOrderComment] = gqlService.placeOrderWithOrderComment({ onError: () => {} });
    const [getSnapOrderStatusByOrderId, snapStatus] = gqlService.getSnapOrderStatusByOrderId({ onError: () => {} });
    const [setCCDataCoreApi] = gqlService.setCCDataCoreApi();
    const [setCCDataCoreApiXendit] = gqlService.setCCDataCoreApiXendit();
    const [getCustCartId, manageCustCartId] = gqlService.getCustomerCartId();
    const [setPaperbagFeeOnCart] = gqlService.setPaperbagFeeOnCart();
    const storeConfigLocalStorage = storeConfigVar();
    // indodana
    const [getIndodanaRedirect, urlIndodana] = gqlService.getIndodanaUrl();
    // xendit
    const [getXenditUrl] = gqlService.xenditCreateInvoice();
    const [coreApiXenditCharges] = gqlService.coreApiXenditCharges();
    const { isDesktop } = useMediaQuery();
    const cashtag = checkout?.cashtag;

    // mutation update delete
    const [actDeleteItem] = gqlService.deleteItemCart();
    const [actUpdateItem] = gqlService.updateItemCart();
    const [getUpdatedCart, updatedCart] = gqlService.getUpdatedCart();

    const validateResponse = (response) => {
        if (response.message) {
            dispatch(setLoading({ order: false }));

            if (response.message.includes('Token is wrong.')) {
                setCheckoutTokenState(!checkoutTokenState);
            } else {
                handleOpenMessage({
                    variant: 'error',
                    text: t('checkout:message:serverError'),
                });
            }

            return false;
        }

        return true;
    };

    const generatesuccessRedirect = (orderNumber) => {
        if (config && config.successRedirect && config.successRedirect.link) {
            return `${config.successRedirect.link}${config.successRedirect.orderId ? `?orderId=${orderNumber}` : ''}`;
        }
        return '/checkout/onepage/success';
    };

    const generateCartRedirect = (orderNumber = '') => {
        if (config && config.cartRedirect && config.cartRedirect.link) {
            if (orderNumber && orderNumber !== '') {
                if (originName === 'pwa-checkout') {
                    return `${getStoreHost(getAppEnv())}snap/payment/fail?order_id=${orderNumber}`;
                }
                return `${getHost()}/checkout/cart?paymentFailed=true&orderId=${orderNumber}`;
            }
            return config.cartRedirect.link;
        }
        return '/checkout/cart';
    };

    // xendit key
    const isProductionXendit = storeConfig?.xendit_core_api_environment === '1';
    let xenditKey = getXenditKeyDev();
    if (isProductionXendit) {
        xenditKey = getXenditKey();
    }

    // coreapi xendit ewallet
    const payment_method_code = checkout?.data?.cart?.selected_payment_method?.code;
    const isEwallet = payment_method_code?.match(/_ewallet/);
    const isPaylater = payment_method_code?.match(/_paylater/);

    // place order xendit
    const [openXendit, setOpenXendit] = useState(false);
    const [xenditIframeUrl, setXenditIframeUrl] = useState('');
    const [xenditState, setXenditState] = useState({});

    const handleXendit = (order_id) => {
        dispatch(setLoading({ order: true }));
        getXenditUrl({
            variables: { order_id },
        })
            .then((res) => {
                if (res && res.data && res.data.xenditCreateInvoice && res.data.xenditCreateInvoice.invoice_url) {
                    setXenditIframeUrl(res.data.xenditCreateInvoice.invoice_url);
                    setXenditState({
                        order_id,
                        payment_code: checkout.data.cart.selected_payment_method.code,
                        mode: res.data.xenditCreateInvoice.mode,
                        xendit_qrcode_external_id: res.data.xenditCreateInvoice.xendit_qrcode_external_id,
                        amount: checkout.data.cart.prices.grand_total.value,
                    });
                    if (modules.checkout.xendit.paymentPrefixCodeOnSuccess.includes(checkout.data.cart.selected_payment_method.code)) {
                        handleOpenMessage({
                            variant: 'success',
                            text: t('checkout:message:placeOrder'),
                        });
                        window.location.replace(generatesuccessRedirect(order_id));
                    } else if (checkout.data.cart.selected_payment_method.code === 'cc_subscription') {
                        window.location.replace(res.data.xenditCreateInvoice.invoice_url);
                    } else {
                        setOpenXendit(true);
                    }
                    dispatch(setLoading({ order: false }));
                } else {
                    dispatch(setLoading({ order: false }));

                    const msg = t('checkout:message:serverError');

                    handleOpenMessage({
                        variant: 'error',
                        text: msg,
                    });

                    setTimeout(() => {
                        window.location.replace(generateCartRedirect(orderId));
                    }, 1000);
                }
            })
            .catch((e) => {
                dispatch(setLoading({ order: false }));

                const msg = e.graphQLErrors.length > 0 ? e.graphQLErrors[0].message : t('checkout:message:serverError');

                handleOpenMessage({
                    variant: 'error',
                    text: msg,
                });

                setTimeout(() => {
                    window.location.replace(generateCartRedirect(order_id));
                }, 1000);
            });
    };

    const handleRedirectCC = () => {
        const redirectUrl = '/checkout/coreapi/payment/cc';
        window.location.replace(redirectUrl);
    };

    const handleRedirectEwallet = (order_id) => {
        const isOVO = checkout.data.cart.selected_payment_method.code.match(/ovo.*/);
        const isJeniusPay = checkout.data.cart.selected_payment_method.code.match(/jeniuspay/);
        const isQRIS = checkout.data.cart.selected_payment_method.code.match(/qris/);

        if (isQRIS) {
            window.location.replace(generatesuccessRedirect(order_id));
        } else {
            coreApiXenditCharges({
                variables: {
                    order_id,
                    ...isJeniusPay && { cashTag: cashtag }
                },
            })
                .then((res) => {
                    const redirectPaymentUrlDesktop = res?.data?.coreApiXenditCharges?.actions?.desktop_web_checkout_url;
                    const redirectPaymentUrlMobile = res?.data?.coreApiXenditCharges?.actions?.mobile_web_checkout_url;
                    const redirectPaymentUrlDeeplink = res?.data?.coreApiXenditCharges?.actions?.mobile_deeplink_checkout_url;

                    if (isOVO || isJeniusPay) {
                        window.location.replace(generatesuccessRedirect(order_id));
                    } else {
                        if (isDesktop) {
                            window.location.replace(redirectPaymentUrlDesktop || redirectPaymentUrlMobile || redirectPaymentUrlDeeplink);
                        } else {
                            window.location.replace(redirectPaymentUrlMobile || redirectPaymentUrlDesktop || redirectPaymentUrlDeeplink);
                        }
                    }
                })
                .catch((e) => {
                    const msg = t('checkout:message:serverError');

                    handleOpenMessage({
                        variant: 'error',
                        text: e?.message || msg,
                    });
                });
        }
    };

    const submitPlaceOrder = async () => {
        window.backdropLoader(true);
        const { cart, isGuest } = checkout.data;
        const involveAsiaClickId = Cookies.get(involveAsiaClickIdCookie);
        const involveAsiaUtmSource = Cookies.get(involveAsiaSourceCookie);
        const involveAsiaUtmMedium = Cookies.get(involveAsiaMediumCookie);
        const { third: gaCookieThirdSegment, fourth: gaCookieFourthSegment } = getGaCookieSegments();
        const gaSessionCombinedValue = [gaCookieThirdSegment, gaCookieFourthSegment].filter((segment) => segment !== '').join('.') || '';

        let formValidation = {};
        let result;
        dispatch(setLoading({ order: true }));

        if (cart.prices.grand_total.value === 0 && cart.selected_payment_method && cart.selected_payment_method.code !== 'free') {
            await setPaymentMethod({
                variables: {
                    cartId: cart.id,
                    payment_method: {
                        code: 'free',
                    },
                },
            })
                .then((res) => {
                    result = res;
                })
                .catch((err) => {
                    result = err;
                });

            if (!validateResponse(result)) return;

            dispatch(
                setCheckoutDataState({
                    cart: {
                        ...checkout.data.cart,
                        ...result.data.setPaymentMethodOnCart.cart,
                    },
                }),
            );
            updateFormik({
                ...checkout.data.cart,
                ...result.data.setPaymentMethodOnCart.cart,
            });
        }

        await formik.submitForm();
        formValidation = await formik.validateForm();

        const isMultiSeller = storeConfigLocalStorage.enable_oms_multiseller === '1' || storeConfigLocalStorage.enable_oms_multiseller === 1;

        if (Object.keys(formValidation).length === 0 && formValidation.constructor === Object) {
            if (checkout.selected.delivery === 'pickup' && (checkout.error.pickupInformation || checkout.error.selectStore)) {
                dispatch(setLoading({ order: false }));

                const msg = t('checkout:completePikcupInfo');
                handleOpenMessage({
                    variant: 'error',
                    text: msg,
                });
            } else {
                if (formik.values.orderComment !== '') {
                    result = await placeOrderWithOrderComment({
                        variables: {
                            cartId: cart.id,
                            origin: originName,
                            orderComment: filterSpecialChars(formik.values.orderComment),
                            // eslint-disable-next-line max-len
                            personalDataConsent: (checkout.data.isGuest || !isPersonalDataConsentCustomer) ? formik.values.personalDataConsent : '1',
                            ...(gaSessionCombinedValue && { ga4_session_id: gaSessionCombinedValue }),
                            ...(involveAsiaClickId && { clickId: involveAsiaClickId }),
                            ...(involveAsiaUtmSource && { utmSource: involveAsiaUtmSource }),
                            ...(involveAsiaUtmMedium && { utmMedium: involveAsiaUtmMedium }),
                        },
                    });
                    // const order_number = await result?.data?.placeOrder[0]?.order?.order_number;
                    // if (order_number) {
                    //     await handleSendPostback(order_number);
                    // }
                    removeInvolveAsiaCookie();
                } else {
                    await placeOrder({
                        variables: {
                            cartId: cart.id,
                            origin: originName,
                            // eslint-disable-next-line max-len
                            personalDataConsent: (checkout.data.isGuest || !isPersonalDataConsentCustomer) ? formik.values.personalDataConsent : '1',
                            ...(gaSessionCombinedValue && { ga4_session_id: gaSessionCombinedValue }),
                            ...(involveAsiaClickId && { clickId: involveAsiaClickId }),
                            ...(involveAsiaUtmSource && { utmSource: involveAsiaUtmSource }),
                            ...(involveAsiaUtmMedium && { utmMedium: involveAsiaUtmMedium }),
                        },
                    })
                        .then(async (res) => {
                            result = res;
                            // const order_number = await res?.data?.placeOrder[0]?.order?.order_number;
                            // if (order_number) {
                            //     await handleSendPostback(order_number);
                            // }
                            removeInvolveAsiaCookie();
                        })
                        .catch((err) => {
                            result = err;
                            removeInvolveAsiaCookie();
                        });
                }

                dispatch(setLoading({ order: false }));

                if (!validateResponse(result)) return;

                let orderNumber = '';
                let infoMsg = '';
                let threeds_redirect_url = '';
                if (isMultiSeller) {
                    if (result.data && result.data.placeOrder[0] && result.data.placeOrder[0].order && result.data.placeOrder[0].order.order_number) {
                        // eslint-disable-next-line array-callback-return
                        result.data.placeOrder.map((order, index) => {
                            if (index !== result.data.placeOrder.length - 1) {
                                orderNumber = `${orderNumber}${order.order.order_number}|`;
                                infoMsg = order.infoMsg;
                            } else {
                                orderNumber = `${orderNumber}${order.order.order_number}`;
                                infoMsg = order.infoMsg;
                            }
                            tempMidtransOrderId.push(order.order.order_number);
                        });
                    }
                } else {
                    if (result.data && result.data.placeOrder[0] && result.data.placeOrder[0].order && result.data.placeOrder[0].order.order_number) {
                        orderNumber = result.data.placeOrder[0].order.order_number;
                        infoMsg = result.data.placeOrder[0].infoMsg;
                        tempMidtransOrderId.push(orderNumber);
                    }
                    if (result.data && result.data.placeOrder[0] && result.data.placeOrder[0].threeds_redirect_url) {
                        threeds_redirect_url = result.data.placeOrder[0].threeds_redirect_url;
                    }
                }
                if (orderNumber && orderNumber !== '') {
                    const threedsRedirectUrlExist = threeds_redirect_url && threeds_redirect_url !== '';
                    if (isMultiSeller) {
                        setCheckoutData({
                            email: isGuest ? formik.values.email : cart.email,
                            order_number: orderNumber,
                            order_id: orderNumber,
                            ...(threedsRedirectUrlExist && { threeds_redirect_url }),
                            provider: checkout.data.cart.selected_payment_method.code.match(/coreapixendit_/) ? 'xendit' : '',
                            infoMsg,
                        });
                    } else {
                        setCheckoutData({
                            email: isGuest ? formik.values.email : cart.email,
                            order_number: orderNumber,
                            order_id: result.data.placeOrder[0].order.order_id,
                            ...(threedsRedirectUrlExist && { threeds_redirect_url }),
                            provider: checkout.data.cart.selected_payment_method.code.match(/coreapixendit_/) ? 'xendit' : '',
                            infoMsg,
                        });
                    }
                    if (client && client.query && typeof client.query === 'function') {
                        await client.query({ query: localTotalCart, data: { totalCart: 0 } });
                    }

                    if (checkout.data.cart.selected_payment_method.code.match(/snap.*/)) {
                        setOrderId(orderNumber);
                        setSnapOrderId(tempMidtransOrderId);
                        await getSnapToken({ variables: { orderId: tempMidtransOrderId } });
                    } else if (
                        // checkout.data.cart.selected_payment_method.code.match(/ovo.*/) ||
                        (checkout.data.cart.selected_payment_method.code.match(/ovo.*/)
                            && !checkout.data.cart.selected_payment_method.code.match(/coreapixendit_/))
                        || checkout.data.cart.selected_payment_method.code.match(/ipay88*/)
                    ) {
                        window.location.href = getIpayUrl(orderNumber);
                    } else if (checkout.data.cart.selected_payment_method.code.match(/indodana/)
                        && !checkout.data.cart.selected_payment_method.code.match(/coreapixendit_/)) {
                        await getIndodanaRedirect({ variables: { order_number: orderNumber } });
                    } else if (
                        modules.checkout.xendit.paymentPrefixCode.includes(checkout.data.cart.selected_payment_method.code)
                        || modules.checkout.xendit.paymentPrefixCodeOnSuccess.includes(checkout.data.cart.selected_payment_method.code)
                    ) {
                        handleXendit(orderNumber);
                    } else if (
                        (checkout.data.cart.selected_payment_method.code.match(/coreapi_/)
                            || checkout.data.cart.selected_payment_method.code.match(/coreapixendit_/))
                        && checkout.data.cart.selected_payment_method.code.match(/_cc/)
                    ) {
                        handleOpenMessage({
                            variant: 'success',
                            text: t('checkout:message:placeOrder'),
                        });
                        handleRedirectCC();
                    } else if (isEwallet || isPaylater) {
                        handleOpenMessage({
                            variant: 'success',
                            text: t('checkout:message:placeOrder'),
                        });
                        handleRedirectEwallet(orderNumber);
                    } else {
                        handleOpenMessage({
                            variant: 'success',
                            text: t('checkout:message:placeOrder'),
                        });
                        window.location.replace(generatesuccessRedirect(orderNumber));
                    }

                    setTimeout(() => {
                        removeCartId();
                    }, 1000);
                } else {
                    dispatch(setLoading({ order: false }));

                    const msg = t('checkout:message:serverError');

                    handleOpenMessage({
                        variant: 'error',
                        text: msg,
                    });
                }
            }
        } else {
            dispatch(setLoading({ order: false }));

            const msg = checkout.data.isGuest ? t('checkout:message:guestFormValidation') : t('checkout:message:customerFormValidation');

            handleOpenMessage({
                variant: 'error',
                text: msg,
            });
        }

        window.backdropLoader(false);
    };

    const handlePlaceOrder = async () => {
        window.backdropLoader(true);
        const { cardData, selected } = checkout;
        const { cart } = checkout.data;
        const cardInput = {
            card_number: cardData.card_number,
            card_cvv: cardData.card_cvv,
            card_exp_month: cardData.card_exp_month.toString(),
            card_exp_year: cardData.card_exp_year.toString(),
        };
        const isCardValid = _.isEmpty(checkout?.cardErrors);
        const isCoreAPI = selected?.payment?.match(/coreapi_/);
        const isCoreAPIXendit = selected?.payment?.match(/coreapixendit_/);
        const isCreditCard = selected?.payment?.match(/_cc/);
        const isJeniusPay = checkout.data.cart.selected_payment_method.code.match(/jeniuspay/);
        if ((isCoreAPI || isCoreAPIXendit) && isCreditCard) {
            if (isCardValid) {
                if (isCoreAPIXendit) {
                    const tokenPayload = {
                        card_number: cardData.card_number,
                        card_exp_month: String(cardData.card_exp_month).padStart(2, '0'),
                        card_exp_year: cardData.card_exp_year.toString(),
                        card_cvn: cardData.card_cvv,
                        is_multiple_use: true,
                        should_authenticate: true,
                        card_holder_first_name: cardData.card_holder_firstname,
                        card_holder_last_name: cardData.card_holder_lastname,
                        card_holder_email: cardData.card_holder_email,
                        card_holder_phone_number: formatPhoneNumber(cardData.card_holder_phone_number),
                    };

                    await createToken(tokenPayload, xenditKey)
                        .then(async (res) => {
                            await setCCDataCoreApiXendit({
                                variables: {
                                    cartId: cart.id,
                                    cardData: {
                                        card_info_brand: res.card_info.brand,
                                        card_info_type: res.card_info.type,
                                        masked_card_number: res.masked_card_number,
                                        status: res.status,
                                        ...cardData?.tenor && { tenor: parseInt(cardData.tenor, 10) || 0, },
                                        token_id: res.id,
                                        card_info_bank: res.card_info.bank,
                                    }
                                }
                            })
                                .then((resCard) => {
                                    window.backdropLoader(false);
                                    if (resCard?.data?.setCCDataCoreApiXendit?.is_valid) {
                                        submitPlaceOrder();
                                    } else {
                                        handleOpenMessage({
                                            variant: 'error',
                                            text: resCard?.data?.setCCDataCoreApiXendit?.message || t('checkout:message:cardInvalid'),
                                        });
                                    }
                                })
                                .catch(() => {
                                    window.backdropLoader(false);
                                    handleOpenMessage({
                                        variant: 'error',
                                        text: t('checkout:message:serverError'),
                                    });
                                });
                        })
                        .catch((e) => {
                            window.backdropLoader(false);
                            handleOpenMessage({
                                variant: 'error',
                                text: e?.message || t('checkout:message:cardInvalid'),
                            });
                        });
                } else {
                    await getCardToken(cardInput)
                        .then(async (res) => {
                            const token_id = res?.token_id;
                            await setCCDataCoreApi({
                                variables: {
                                    cartId: cart.id,
                                    cardData: {
                                        ...cardData?.tenor && { tenor: parseInt(cardData.tenor, 10) || 0, },
                                        token_id,
                                    }
                                }
                            })
                                .then((resCard) => {
                                    window.backdropLoader(false);
                                    if (resCard?.data?.setCCDataCoreApi?.is_valid) {
                                        submitPlaceOrder();
                                    } else {
                                        handleOpenMessage({
                                            variant: 'error',
                                            text: resCard?.data?.setCCDataCoreApi?.message || t('checkout:message:cardInvalid'),
                                        });
                                    }
                                })
                                .catch(() => {
                                    window.backdropLoader(false);
                                    handleOpenMessage({
                                        variant: 'error',
                                        text: t('checkout:message:serverError'),
                                    });
                                });
                        })
                        .catch((err) => {
                            window.backdropLoader(false);
                            handleOpenMessage({
                                variant: 'error',
                                text: err?.validation_messages[0] || t('checkout:message:serverError'),
                            });
                        });
                }
            } else {
                handleOpenMessage({
                    variant: 'error',
                    text: t('checkout:message:cardInvalid'),
                });
            }
        } else if (isJeniusPay) {
            if (!checkout?.cashtagError) {
                submitPlaceOrder();
            } else {
                handleOpenMessage({
                    variant: 'error',
                    text: 'Informasi cashtag tidak valid, silahkan periksa kembali',
                });
            }
        } else {
            submitPlaceOrder();
        }
    };

    // manage indodana redirect
    if (!urlIndodana.loading && urlIndodana.data && urlIndodana.data.indodanaRedirectUrl && urlIndodana.data.indodanaRedirectUrl.redirect_url) {
        window.location.replace(urlIndodana.data.indodanaRedirectUrl.redirect_url);
    }

    useEffect(() => {
        if (!urlIndodana.loading && urlIndodana.error) {
            const msg = t('checkout:message:serverError');

            handleOpenMessage({
                variant: 'error',
                text: msg,
            });
        }
    }, [urlIndodana]);

    // Start - Manage Snap Pop Up When Opened (Waiting Response From SnapToken)
    if (
        manageSnapToken.data
        && orderId
        && snapOrderId
        && !snapOpened
        && manageSnapToken.data.getSnapTokenByOrderId
        && manageSnapToken.data.getSnapTokenByOrderId.snap_token
    ) {
        const snapToken = manageSnapToken.data.getSnapTokenByOrderId.snap_token;
        if (snap && snap.pay) {
            snap.pay(snapToken, {
                async onSuccess() {
                    window.location.replace(generatesuccessRedirect(orderId));
                },
                async onPending() {
                    window.location.replace(generatesuccessRedirect(orderId));
                },
                async onError() {
                    window.backdropLoader(true);
                    getSnapOrderStatusByOrderId({
                        variables: {
                            orderId: snapOrderId,
                        },
                    });

                    if (!checkout.data.isGuest) {
                        getCustCartId();
                    }

                    setSnapOpened(true);
                },
                async onClose() {
                    window.backdropLoader(true);
                    getSnapOrderStatusByOrderId({
                        variables: {
                            orderId: snapOrderId,
                        },
                    });

                    if (!checkout.data.isGuest) {
                        getCustCartId();
                    }

                    setSnapOpened(true);
                },
            });
        }
    }

    if (manageSnapToken.error && orderId) {
        window.location.replace(generateCartRedirect(orderId));
    }
    // End - Manage Snap Pop Up When Opened (Waitinge Response From SnapToken)

    // Start - Process Snap Pop Up Close (Waitinge Response From Reorder)
    if (snapStatus.data && !snapClosed) {
        const { cart_id, order_id } = snapStatus.data.getSnapOrderStatusByOrderId;
        setSnapClosed(true);

        if (!checkout.data.isGuest && manageCustCartId.data) {
            const { id: customerCartId } = manageCustCartId.data.customerCart;
            setCartId(customerCartId);
            setOrderId(null);
            setSnapOrderId([]);
            window.location.replace(generateCartRedirect(order_id));
        } else {
            setCartId(cart_id);
            setOrderId(null);
            setSnapOrderId([]);
            window.location.replace(generateCartRedirect(order_id));
        }
    }
    // End - Process Snap Pop Up Close (Waitinge Response From Reorder)

    const cartRef = useRef(checkout.data.cart);
    cartRef.current = checkout.data.cart;

    const setCart = (cart = {}) => {
        dispatch(
            setCheckoutDataState({
                cart: { ...cartRef.current, ...cart },
            }),
        );
    };

    // Paperbag fee: derive carrier code from selected shipping (immediate, for UI display)
    const shippingSelected = checkout.selected.shipping;
    let selectedCarrierCode = null;
    if (Array.isArray(shippingSelected)) {
        selectedCarrierCode = shippingSelected?.[0]?.name?.carrier_code;
    } else if (typeof shippingSelected === 'string' && shippingSelected) {
        // eslint-disable-next-line prefer-destructuring
        selectedCarrierCode = shippingSelected.split('_')[0];
    }
    // Carrier code from actual cart data — only updates AFTER shipping mutation resolves.
    // Using this (not selectedCarrierCode) as the auto-apply trigger prevents the race condition
    // where paperbag fires before the backend has committed the new shipping method.
    const cartCarrierCode = checkout.data.cart?.shipping_addresses?.[0]?.selected_shipping_method?.carrier_code ?? null;

    const isJne = selectedCarrierCode?.toLowerCase().includes('jne');
    const isGosend = selectedCarrierCode?.toLowerCase().includes('gosend');
    const showPaperbagFee = isJne || isGosend;
    const paperbagFeeLocked = isGosend;

    const [paperbagFeeChecked, setPaperbagFeeChecked] = useState(false);
    const [paperbagFeeLoading, setPaperbagFeeLoading] = useState(false);

    useEffect(() => {
        if (!showPaperbagFee) {
            setPaperbagFeeChecked(false);
        }
    }, [showPaperbagFee]);

    // Show paperbag checkbox as optimistically checked while:
    // 1. The shipping mutation is in flight (selectedCarrierCode ≠ cartCarrierCode), OR
    // 2. Auto-apply hasn't fired yet for the current cart carrier
    const prevCarrierRef = useRef(null);
    const paperbagAutoApplyPending = showPaperbagFee && selectedCarrierCode !== cartCarrierCode;
    const paperbagFeeCheckedDisplay = paperbagFeeChecked || paperbagAutoApplyPending;

    useEffect(() => {
        if (!showPaperbagFee) return undefined;
        const cartIdLocal = checkout.data.cart?.id;
        if (!cartIdLocal) return undefined;
        // Gate 1: fire only after shipping mutation resolves (cartCarrierCode reflects the new carrier)
        if (!cartCarrierCode) return undefined;
        // Gate 2: wait for getPrice query to complete (newupdate/totalPrice = true while getPrice in-flight)
        // Without this, paperbag fires before getPrice finishes, and getPrice response overwrites our prices
        if (checkout.loading.totalPrice || checkout.newupdate) return undefined;
        if (prevCarrierRef.current === cartCarrierCode) return undefined;
        prevCarrierRef.current = cartCarrierCode;
        setPaperbagFeeLoading(true);
        const timerId = setTimeout(() => {
            setPaperbagFeeOnCart({
                variables: { input: { cart_id: cartIdLocal, paperbag_selected: true } },
            }).then((res) => {
                if (res?.data?.setPaperbagFeeOnCart?.cart) {
                    // Update prices only — do NOT overwrite shipping_addresses to
                    // avoid triggering core.js useEffect([cart]) that resets shipping selection
                    if (res.data.setPaperbagFeeOnCart.cart.prices) {
                        setCart({ prices: res.data.setPaperbagFeeOnCart.cart.prices });
                    }
                    setPaperbagFeeChecked(true);
                }
            }).catch(() => {}).finally(() => {
                setPaperbagFeeLoading(false);
            });
        }, 0);
        return () => {
            clearTimeout(timerId);
            prevCarrierRef.current = null;
            setPaperbagFeeLoading(false);
        };
    }, [cartCarrierCode, checkout.data.cart?.id, checkout.loading.totalPrice, checkout.newupdate]);

    const handlePaperbagFee = (selected) => {
        const cartIdLocal = checkout.data.cart?.id;
        if (!cartIdLocal || paperbagFeeLocked || paperbagFeeLoading) return;
        setPaperbagFeeLoading(true);
        setPaperbagFeeOnCart({
            variables: { input: { cart_id: cartIdLocal, paperbag_selected: selected } },
        }).then((res) => {
            if (res?.data?.setPaperbagFeeOnCart?.cart) {
                setCart(res.data.setPaperbagFeeOnCart.cart);
                setPaperbagFeeChecked(selected);
            }
        }).catch(() => {}).finally(() => {
            setPaperbagFeeLoading(false);
        });
    };

    const setLoadSummary = (load = false) => {
        window.backdropLoader(load);
        dispatch(
            setLoading({
                addresses: load,
                order: load,
                shipping: load,
                payment: load,
                extraFee: load,
            }),
        );
    };

    useEffect(() => {
        if (!updatedCart.loading && updatedCart.data) {
            setLoadSummary(false);
            window.toastMessage({
                open: true,
                text: t('common:cart:updateSuccess'),
                variant: 'success',
            });
            setCart({ ...updatedCart.data.cart });
        }
    }, [updatedCart.loading]);

    useEffect(() => {
        if (typeof refSummary !== 'undefined') {
            // eslint-disable-next-line no-param-reassign
            refSummary.current = {
                handlePlaceOrder,
            };
        }
    }, [refSummary]);
    const Loader = () => (
        <>
            <Skeleton className="rounded-[50%] mb-[5px]" width="100%" height={300} />
            <Skeleton className="rounded-[50%] mb-[5px]" width="100%" height={50} />
        </>
    );
    if (checkout.loading.all) {
        return <Loader />;
    }

    // update items
    const updateCart = (id, qty) => {
        setLoadSummary(true);
        actUpdateItem({
            variables: {
                cartId: checkout.data.cart.id,
                cart_item_id: parseInt(id, 10),
                quantity: qty,
            },
            context: {
                request: 'internal',
            },
        })
            .then((res) => {
                if (res && res.data && res.data.updateCartItems && res.data.updateCartItems.cart) {
                    getUpdatedCart({ variables: { cartId: checkout.data.cart.id } });
                }
            })
            .catch((e) => {
                setLoadSummary(false);
                window.toastMessage({
                    open: true,
                    text: e.message.split(':')[1] || t('common:cart:updateFailed'),
                    variant: 'error',
                });
            });
    };

    const deleteCart = (id) => {
        setLoadSummary(true);
        actDeleteItem({
            variables: {
                cartId: checkout.data.cart.id,
                cart_item_id: parseInt(id, 10),
            },
            context: {
                request: 'internal',
            },
        })
            .then((res) => {
                if (res && res.data && res.data.removeItemFromCart && res.data.removeItemFromCart.cart) {
                    setLoadSummary(false);
                    window.toastMessage({
                        open: true,
                        text: t('common:cart:deleteSuccess'),
                        variant: 'success',
                    });
                    if (res.data.removeItemFromCart.cart.items === null || res.data.removeItemFromCart.cart.items.length === 0) {
                        window.location.replace(generateCartRedirect());
                    } else {
                        setCart({ ...res.data.removeItemFromCart.cart });
                    }
                }
            })
            .catch((e) => {
                setLoadSummary(false);
                window.toastMessage({
                    open: true,
                    text: e.message.split(':')[1] || t('common:cart:deleteFailed'),
                    variant: 'error',
                });
            });
    };

    // check error items
    if (checkout.data.cart.errorItems && checkout.data.cart.errorItems?.length > 0) {
        const errorMessage = {
            variant: 'warning',
            text: checkout.data.cart.errorItems[0],
            open: true,
        };
        window.toastMessage({
            ...errorMessage,
        });
        setTimeout(() => {
            Router.push('/checkout/cart');
        }, 3000);
    }

    // remove coupon error
    const filteredErrorItems = Object.keys(formik.errors).filter((key) => key !== 'coupon');

    if (checkout && checkout.data && checkout.data.cart && checkout.loading) {
        const disablePlaceOrder = errorItems || disabled || (isSelectedPurchaseOrder && !isPurchaseOrderApply) || checkout.error.shippingAddress
        || (formik && filteredErrorItems.length);
        return (
            <>
                <ModalXendit open={openXendit} setOpen={() => setOpenXendit(!openXendit)} iframeUrl={xenditIframeUrl} {...xenditState} />
                {buttonOnly ? (
                    <Button
                        disabled={disablePlaceOrder}
                        className="w-full"
                        classNameText="justify-center text-lg"
                        loading={loading}
                        onClick={
                            () => {
                                if (!loading) {
                                    handlePlaceOrder();
                                }
                            }
                        }
                    >
                        {t('checkout:placeOrder')}
                    </Button>
                ) : (
                    <SummaryPlugin
                        t={t}
                        loadTotal={totalPrice}
                        loading={loading}
                        isLoader={checkout.loading.order}
                        disabled={
                            disablePlaceOrder
                        }
                        handleActionSummary={() => {
                            if (!loading) {
                                handlePlaceOrder();
                            }
                        }}
                        dataCart={checkout.data.cart}
                        showItems
                        label={t('checkout:placeOrder')}
                        globalCurrency={globalCurrency}
                        updateCart={updateCart}
                        deleteCart={deleteCart}
                        withAction
                        hideButton
                        storeConfig={storeConfig}
                        mobilePosition="bottom" // top: static on top, bottom: assolute on bottom like bottom sheet
                        rewardPageId={2}
                        isCheckoutPage
                        showPaperbagFee={showPaperbagFee}
                        paperbagFeeLocked={paperbagFeeLocked}
                        paperbagFeeChecked={paperbagFeeCheckedDisplay}
                        paperbagFeeLoading={paperbagFeeLoading}
                        handlePaperbagFee={handlePaperbagFee}
                    />
                )}
            </>
        );
    }

    return null;
};

export default Summary;
